import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  background:  #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter, sans-serif;
`;

export const LoginCard = styled.div`
  width: 620px;
  padding: 35px 40px;
  background: #fff;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 4px 30px rgba(0,0,0,0.1);
`;

export const Logo = styled.img`
  width: 173px;
`;

export const Title = styled.h1`
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 5px;
`;

export const SubTitle = styled.p`
  font-size: 18px;
  color: #6B7280;
  margin-bottom: 32px;
`;

export const Label = styled.label`
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  display: block;
  text-align: left;
  margin-bottom: 8px;
`;

export const InputWrapper = styled.div`
  width: 100%;
  height: 58px;
  background: #F9FAFB;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  border: 1px solid #E5E7EB;
`;

export const IconLeft = styled.div`
  position: absolute;
  left: 14px;
`;

export const IconRight = styled.div`
  position: absolute;
  right: 14px;
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  border: none;
  outline: none;
  border-radius: 10px;
  padding-left: 42px;
  padding-right: 42px;
  font-size: 18px;
  background: transparent;
`;

export const ForgotPassword = styled.a`
  display: block;
  width: 100%;
  text-align: right;
  font-size: 18px;
  font-weight: 700;
  color: #4F46E5;
  cursor: pointer;
  margin-bottom: 25px;

  &:hover {
    text-decoration: underline;
  }
`;

export const LoginButton = styled.button`
  width: 100%;
  height: 70px;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(90deg, #2563EB, #3B82F6);
  color: white;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;